import jsonp from "jsonp";
import axios from "axios";
import gloabaleConfig from "../utiles/globalConfig";
import languages from "./languages";
import {convertParamToString} from "../utiles";

const MAIN_HOST = gloabaleConfig.getMainHost();

export const PLATFORM_HOST = "";
export const ACHIEVEMENT_ID = 9999;
export const APP_ID = 182267189223689;
export const HOST = `//geventsapi.${MAIN_HOST}/`;
export const PASSPORT_HOST = `//gpassport.${MAIN_HOST}/`;
export const STORE_HOST = `//gstore.${MAIN_HOST}/`;
export const SUPPORT_REQ_URL =  `//gsupport.${MAIN_HOST}/index`;
export const HOME_HOST = `//www.${MAIN_HOST}/`;
export const H5_HOST = `//h5.${MAIN_HOST}/`;
export const FUNCTION_LIST_STORE ="functionList";
export let ERR_CODE = "0";
export const DEFAULT_LANGUAGE = "en-US"
import qs from 'qs'
const SUCCESS_RESULT_CODE = 1;

export const isEmptyObj = function(obj) {
  return !Object.keys(obj).length
}

export let appendEntryPageParams = function(params){
    if(params.needntEntryParam){
        return params;
    }
    let entryPageParam = gloabaleConfig.getAllWebviewEntryParams();
    return Object.assign(entryPageParam,params)
}

export let post = function(action, params) {
    
    languages.init();
    if(!params["language"]){
        params["language"] = getHrefParam("language")  || DEFAULT_LANGUAGE;
        params["appLanguage"] = getHrefParam("appLanguage")  || DEFAULT_LANGUAGE;
    }
    params  = appendEntryPageParams(params);
    return new Promise((resolve, reject) => {
        axios.post(action, qs.stringify(params))
            .then(function(response) {
                var res = response.data;
                if (SUCCESS_RESULT_CODE != res.result) {
                    var errmsg = res && res.msg && res.msg.replace(/\[\-\d*\]/, "") || "";
                     if (res && res.code !== void 0) {
                       errmsg = languages.get(res.code);
                     }
                    resolve({
                        errmsg: errmsg,
                        data: [],
                        res: response
                    });
                } else {
                    resolve({
                        errmsg: "",
                        data: res.data,
                        res: res
                    });
                }
            })
            .catch(function(error) {
                console.log(error);
            });
    });
}

export let getJSON = function(action, params) {
    languages.init();
    if(!params["language"]){
        params["language"] = getHrefParam("language")  || DEFAULT_LANGUAGE;
        params["appLanguage"] = getHrefParam("appLanguage")  || DEFAULT_LANGUAGE;
    }
    if("undefined" != typeof window){
        return getJSONP(action, params);
    }else{
        return get(action, params);
    }
}

export let get = function(action, params){
    params  = appendEntryPageParams(params)
    return new Promise((resolve, reject) => {
        axios.get(action, {
            params
        }).then(function(response) {
            var res = response.data;
            if (SUCCESS_RESULT_CODE != res.result) {
                var errmsg = res && res.msg && res.msg.replace(/\[\-\d*\]/, "") || "";
                 if (res && res.code !== void 0) {
                   errmsg = languages.get(res.code);
                 }
                resolve({
                    errmsg: errmsg,
                    data: [],
                    res: response
                });
            } else {
                resolve({
                    errmsg: "",
                    data: res.data,
                    res: res
                });
            }
        })
        .catch(function(error) {
            console.log(error);
        });
    });
}

let getJSONP = function(action, params){
    params  = appendEntryPageParams(params)
    return new Promise((resolve, reject) => {
        var paramStr = convertParamToString(params || {});
        jsonp(action, {
            prefix: "jsonpCallback",
            param: paramStr
        }, (err, response) => {
            if (err || SUCCESS_RESULT_CODE != response.result) {
                var errmsg = response && response.msg && response.msg.replace(/\[\-\d*\]/, "");
                 if (response && response.code !== void 0) {
                   errmsg = languages.get(response.code);
                 }
                resolve({
                    errmsg: errmsg,
                    data: [],
                    res: response
                });
            } else {
                resolve({
                    errmsg: "",
                    data: response.data,
                    res: response
                });
            }
        })
    });
}

export let getHrefParam = function(paramName) {
    return gloabaleConfig.getHrefParam(paramName);
}


 /*
         去除字符串前后的空格
 */
export let  trim = function(str) {
    return str.replace(/(^\s*)|(\s*$)/g, '');
}

export const loadConverstData = function(loadData, map) {
    var result = {}
    for (let key in map) {
        let mapKey = map[key];
        let val = loadData[mapKey] || "";
        result[key] = val;
    }
    return result;
}


export let getGameId = function() {
    return getHrefParam('game_id') || getHrefParam('gameid');
}



export const formatTextAreaVal = function(inputVal) {
    //匹配换行符==> <br/>，空白字符==>&nbsp;
    return inputVal.replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;');
}

export let getShareContent = function(config, action) {
    return new Promise((resolve, reject) => {
        post(action, {
            achievementId: config.achievementId,
            appId: APP_ID,
            gameId: getGameId(),
            serverId: config.serverId,
            fbid: config.fbid || "",
            loginAccount: config.name,
            timestamp: new Date().getTime(),
            roleId: config.roleId,
            roleName: config.roleName,
            devicePlate: "pc",
            pic: ""
        }).then(({ errmsg, data }) => {
            if (errmsg) {
                resolve({
                    link: "",
                    token: "",
                    errmsg: errmsg
                })
            } else {
                resolve({
                    link: data.LINK,
                    token: data.TOKEN,
                    errmsg: ""
                })
            }

        })
    })
}

var formatTimeBit = function(time) {
    if (time < 10) {
        time = "0" + time
    }
    return time;
}


//得到标准时区的时间的函数
export let getLocalTime  = function (i, timestamp) {
    //参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
    if (typeof i !== 'number') return;
    var d = new Date();
    //得到1970年一月一日到现在的秒数
    var len = d.getTime(timestamp);
    //本地时间与GMT时间的时间偏移差
    var offset = d.getTimezoneOffset() * 60000;
    //得到现在的格林尼治时间
    var utcTime = len + offset;
    return new Date(utcTime + 3600000 * i);
}
export let mapDateTime = function(time) {
    var date = getLocalTime(9, time);
    return date.getFullYear() + "-" + formatTimeBit((date.getMonth() + 1)) + "-" + formatTimeBit(date.getDate());
}


